import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiUrls } from '../../../config/api-urls/api-urls';
import { MainService } from '../../../provider/main.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  data: any;
  form: FormGroup;
  patientList: any = [];
  patientCsvArr: any = [];
  therapistList: any = [];
  programList: any = [];
  maxDate: Date | any;

  constructor(private service: MainService, private router: Router) {
    this.form = new FormGroup({
      Patient: new FormControl('', Validators.required),
      Medical: new FormControl('', Validators.required),
      Therapist: new FormControl('', Validators.required),
      Program: new FormControl('', Validators.required),
      fromDate: new FormControl(''),
      toDate: new FormControl(''),
    });

  }

  ngOnInit() {
    this.getDashboardData();
    const currentYear = new Date()
    this.maxDate = new Date(currentYear);
  }

  getDashboardData() {
    this.service.showSpinner()
    this.service.getApi(ApiUrls.dashboard, 1).subscribe((res: any) => {
      localStorage.setItem('responseCode', res.responseCode);
      this.service.isToken.next(res.responseCode)
      if (res.responseCode == 200) {
        this.data = res
        this.service.hideSpinner();
      } else {
        this.service.hideSpinner();
        if (res.responseCode === 401) {
          this.service.errorToast('Your token is expired , please login again.');
          localStorage.removeItem('token');
          localStorage.removeItem('responseCode');
          this.service.loginStatus.next(false);
          this.router.navigate(['/login']);
        }
      }
    })
  }

  // generate Report Method 
  generateReport() {
    if (this.form.controls.Patient.valid) {
      this.PatientListApi()
    }
    else if (this.form.controls.Medical.valid) {
      this.getPhysicianList()
    }
    else if (this.form.controls.Therapist.valid) {
      this.getTherapistList()
    }
    else if (this.form.controls.Program.valid) {
      this.viewProgramList()
    }
  }

  // patient list api integration 

  PatientListApi() {
    if (this.form.value.fromDate && this.form.value.toDate) {
      if (this.form.value.fromDate > this.form.value.toDate) {
        this.service.errorToast('Start time should be less than end time');
        return

      }
    }

    if (!this.form.value.fromDate || !this.form.value.toDate) {
      this.service.errorToast('Dates are required.');
      return
    }


    let date = new Date(this.form.value.fromDate);
    let year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let dt: any = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }

    let date1 = new Date(this.form.value.toDate);
    let year1 = date1.getFullYear();
    let month1: any = date1.getMonth() + 1;
    let dt1: any = date1.getDate();

    if (dt1 < 10) {
      dt1 = '0' + dt1;
    }
    if (month1 < 10) {
      month1 = '0' + month1;
    }

    const data = {
      "search": "",
      "fromDate": year + '-' + month + '-' + dt,
      "toDate": year1 + '-' + month1 + '-' + dt1,
    }

    this.service.showSpinner()
    this.service.postApi(ApiUrls.patientList, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.patientList = res.result;
        this.service.hideSpinner();
        this.patientCsvArr = []
        this.patientList.forEach((ele: any, index: number) => {
          let date = new Date(ele.createdAt);
          let year = date.getFullYear();
          let month: any = date.getMonth() + 1;
          let dt: any = date.getDate();

          if (dt < 10) {
            dt = '0' + dt;
          }
          if (month < 10) {
            month = '0' + month;
          }
          let finalDate = dt + '/' + month + '/' + year;

          this.patientCsvArr.push({
            "Sr. No.": index + 1,
            "Patient name": ele.firstName + ' ' + ele.lastName,
            "Email address": ele.email,
            "Date of joining": finalDate,
            "Therapist Name": ele.myTherapist.length != 0 ? ele.myTherapist[0].firstName + ' ' + ele.myTherapist[0].lastName : "NA",
            "Program": ele.programSubscription ? ele.programSubscription.title : "NA",
          })
        });
        this.exportCsv()

      }
      else {
        this.service.hideSpinner();
        this.service.errorToast(res.responseMessage)
      }

    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  // PhysicianList api integration
  getPhysicianList() {
    if (this.form.value.fromDate && this.form.value.toDate) {
      if (this.form.value.fromDate > this.form.value.toDate) {
        this.service.errorToast('Start time should be less than end time');
        return

      }
    }

    if (!this.form.value.fromDate || !this.form.value.toDate) {
      this.service.errorToast('Dates are required.');
      return
    }
    let date = new Date(this.form.value.fromDate);
    let year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let dt: any = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }

    let date1 = new Date(this.form.value.toDate);
    let year1 = date1.getFullYear();
    let month1: any = date1.getMonth() + 1;
    let dt1: any = date1.getDate();

    if (dt1 < 10) {
      dt1 = '0' + dt1;
    }
    if (month1 < 10) {
      month1 = '0' + month1;
    }

    const data = {
      "role": 'MEDICAL',
      "fromDate": year + '-' + month + '-' + dt,
      "toDate": year1 + '-' + month1 + '-' + dt1,
    }
    this.service.showSpinner();
    this.service.postApi(ApiUrls.therapistList, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.therapistList = []
        this.therapistList = res.result;
        this.patientCsvArr = []
        this.therapistList.forEach((ele: any, index: number) => {
          let date = new Date(ele.createdAt);
          let year = date.getFullYear();
          let month: any = date.getMonth() + 1;
          let dt: any = date.getDate();

          if (dt < 10) {
            dt = '0' + dt;
          }
          if (month < 10) {
            month = '0' + month;
          }
          let finalDate = dt + '/' + month + '/' + year;
          this.patientCsvArr.push({
            "Sr. No.": index + 1,
            "Therapist name": ele.lastName ? ele.firstName + ' ' + ele.lastName : ele.firstName,
            "Email address": ele.email,
            "Specialty": ele.speciality,
            "Type": ele.role,
            "Date Of Joining": finalDate,
            "Assigned to": ele.myPatient.length != 0 ? ele.myPatient[0].firstName + ' ' + ele.myPatient[0].lastName : "NA",
          })

        });
        this.physicianExportCsv();
      } else {
        this.service.errorToast(res.responseMessage)
      }
    })
  }

  // PhysicianList api integration
  getTherapistList() {
    if (this.form.value.fromDate && this.form.value.toDate) {
      if (this.form.value.fromDate > this.form.value.toDate) {
        this.service.errorToast('Start time should be less than end time');
        return

      }
    }
    if (!this.form.value.fromDate || !this.form.value.toDate) {
      this.service.errorToast('Dates are required.');
      return
    }

    let date = new Date(this.form.value.fromDate);
    let year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let dt: any = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }

    let date1 = new Date(this.form.value.toDate);
    let year1 = date1.getFullYear();
    let month1: any = date1.getMonth() + 1;
    let dt1: any = date1.getDate();

    if (dt1 < 10) {
      dt1 = '0' + dt1;
    }
    if (month1 < 10) {
      month1 = '0' + month1;
    }

    const data = {
      "role": 'THERAPIST',
      "fromDate": year + '-' + month + '-' + dt,
      "toDate": year1 + '-' + month1 + '-' + dt1,
    }
    this.service.showSpinner();
    this.service.postApi(ApiUrls.therapistList, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.therapistList = []
        this.therapistList = res.result;
        this.patientCsvArr = []
        this.therapistList.forEach((ele: any, index: number) => {
          let date = new Date(ele.createdAt);
          let year = date.getFullYear();
          let month: any = date.getMonth() + 1;
          let dt: any = date.getDate();

          if (dt < 10) {
            dt = '0' + dt;
          }
          if (month < 10) {
            month = '0' + month;
          }
          let finalDate = dt + '/' + month + '/' + year;
          this.patientCsvArr.push({
            "Sr. No.": index + 1,
            "Therapist name": ele.lastName ? ele.firstName + ' ' + ele.lastName : ele.firstName,
            "Email address": ele.email,
            "Specialty": ele.speciality,
            "Type": ele.role,
            "Date Of Joining": finalDate,
            "Assigned to": ele.myPatient.length != 0 ? ele.myPatient[0].firstName + ' ' + ele.myPatient[0].lastName : "NA",
          })

        });
        this.therapistExportCsv();
      } else {
        this.service.errorToast(res.responseMessage)
      }
    })
  }

  // program list api inntegration 
  viewProgramList() {

    this.service.showSpinner();
    this.service.getApi(ApiUrls.programList, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.patientCsvArr = [];
        this.programList = res.result;
        this.programList.forEach((ele: any, index: number) => {
          this.patientCsvArr.push({
            "Sr. No.": index + 1,
            "Program name": ele.title,
            "Type": ele.programType,
            "Program Amount($)": '$' + ele.amount,
            "Description": ele.description,
          })
        });
        this.programExportCsv();
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }


  // export csv format

  exportCsv() {
    var options = {
      showLabels: true,
      headers: ["Sr. No.", "Patient name", "Email address", "Date of joining"
        , "Therapist Name", "Program"]
    };
    new ngxCsv(this.patientCsvArr, 'Patients Report', options);
  }
  physicianExportCsv() {
    var options = {
      showLabels: true,
      headers: ["Sr. No.", "Therapist name", "Email address", "Specialty", "Type"
        , "Date Of Joining", "Assigned to"]
    };
    new ngxCsv(this.patientCsvArr, 'Medical Report', options);
  }
  therapistExportCsv() {
    var options = {
      showLabels: true,
      headers: ["Sr. No.", "Therapist name", "Email address", "Specialty", "Type"
        , "Date Of Joining", "Assigned to"]
    };
    new ngxCsv(this.patientCsvArr, 'Therapist Report', options);
  }

  programExportCsv() {
    var options = {
      showLabels: true,
      headers: ["Sr. No.", "Program name", "Type", "Program Amount($)", "Description"]
    };
    new ngxCsv(this.patientCsvArr, 'Program Report', options);
  }

}
